<div class="reporter-body">
  <ng-content></ng-content>
</div>
